import {
  getPlaceCachePartition,
  getReadyPlaceFromCacheEntry,
} from 'lib/places/placeCacheUtils'

import { DEFAULT_LOCALE } from 'i18n/util/locale'

export const getActiveLocale = (state: App.State): string => state.geo.locale ?? DEFAULT_LOCALE

export function getResolvedPlace(
  state: App.State,
  placeId: string,
  locale: string,
): App.Place | undefined {
  const entry = getPlaceCachePartition(state.destination.placeCacheByLocale, locale)[placeId]
  return getReadyPlaceFromCacheEntry(entry)
}

export function getPlaceCacheEntriesForIds(
  state: App.State,
  placeIds: ReadonlyArray<string>,
  locale: string,
): Record<string, App.PlaceCacheEntry | undefined> {
  const partition = getPlaceCachePartition(state.destination.placeCacheByLocale, locale)
  const result: Record<string, App.PlaceCacheEntry | undefined> = {}
  for (const id of placeIds) {
    result[id] = partition[id]
  }
  return result
}
